import { ApiError } from '@/lib/api/client';

export const toTrimmed = (value: string) => value.trim();

export const buildContactPayload = (form: {
  name: string;
  email: string;
  phone: string;
  message: string;
}) => {
  const name = toTrimmed(form.name);
  const email = toTrimmed(form.email);
  const phone = toTrimmed(form.phone);
  const message = toTrimmed(form.message);

  return {
    name,
    email,
    phone: phone || undefined,
    message
  };
};

export const resolveErrorMessage = (error: unknown) => {
  if (error instanceof ApiError) {
    return error.status
      ? `Something went wrong (error ${error.status}). Please try again.`
      : 'Something went wrong. Please try again.';
  }

  return 'Something went wrong. Please try again.';
};
